module.exports = __webpack_public_path__ + "PrimordialZoo.webp?64e4a0fc44c1ee3825bdddeee4fc99a8";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/PrimordialZoo.webp
// module id = 152
// module chunks = 0